import { registerModal } from 'features/Modal/ModalRegistry'
import { MobileServiceFormModal } from './MobileServiceFormModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'MOBILE_SERVICE_FORM_MODAL'
registerModal(modalType, MobileServiceFormModal)
export const showMobileServiceFormModal = modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
    },
  })



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceFormModal/MobileServiceFormModal.action.ts